export default "__VITE_ASSET__e3384485__"